<ng-container *transloco="let t">
  <ng-container *ngIf="visible === true">

    <app-loader [loading]="loading"></app-loader>

    <p-card *ngIf="loading !== true">

      <div class="p-grid">
        <div class="p-col-3"><h2>{{ t('common.labels.suggestions') }}</h2></div>
        <div class="p-col-9 p-d-flex p-jc-end p-ai-center">
          <div class="p-mr-1">
            <p-inputSwitch [(ngModel)]="filterDate" tabindex="0" (onChange)="onFiltersUpdated()"></p-inputSwitch>
          </div>
          <div class="p-mr-4">
            {{ t('move_order.labels.selected_date_only') }}
          </div>
          <div class="p-mr-1">
            <p-inputSwitch [(ngModel)]="filterLocation" tabindex="0" (onChange)="onFiltersUpdated()"></p-inputSwitch>
          </div>
          <div class="p-mr-4">
            {{ t('move_order.labels.selected_location_only') }}
          </div>
          <!-- <div class="p-mr-1">
            <p-inputSwitch [(ngModel)]="filterStuff" tabindex="0" (onChange)="onFiltersUpdated()"></p-inputSwitch>
          </div>
          <div>
            {{ t('move_order.labels.actual_staff_only') }}
          </div> -->
        </div>
      </div>

      <p-table
        [value]="filteredSuggestions"
        rowGroupMode="rowspan"
        groupRowsBy="date_as_string"
        [paginator]="true"
        [rows]="10"
        styleClass="p-datatable-sm"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >

        <ng-template pTemplate="header">
          <tr>
            <th>{{ t('common.labels.date') }}</th>
            <th>{{ t('common.labels.location') }}</th>
            <th>{{ t('common.labels.moderators') }}</th>
            <th>{{ t('common.labels.observers') }}</th>
            <th *ngIf="needsGem()">{{ t('common.labels.observers_gem') }}</th>
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-suggestion let-rowIndex="rowIndex" let-rowgroup="rowgroup" let-rowspan="rowspan">
          <tr>
            <td *ngIf="rowgroup" [attr.rowspan]="rowspan">{{ suggestion.date | amLocal | amDateFormat:'DD.MM.YYYY' }}</td>
            <td>{{ suggestion.location?.name }}</td>
            <td>
              {{ suggestion.moderator.concat(suggestion.moderator_external) | arrayToList:', ':'fullname' }}
            </td>
            <td>{{ suggestion.observer | arrayToList:', ':'fullname' }}</td>
            <td *ngIf="needsGem()">{{ suggestion.observer_gem | arrayToList:', ':'fullname' }}</td>
            <td class="p-text-right">
              <button type="button" pButton [label]="t('common.labels.select')" (click)="selectSuggestion(suggestion)" class="p-button-outlined p-button-sm"></button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data p-pt-4 p-pb-4" colspan="6">{{ t('move_order.labels.no_suggestions') }}</td>
          </tr>
        </ng-template>

      </p-table>

    </p-card>

  </ng-container>
</ng-container>
